<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppArrowUp',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="25px"
      height="24px"
      viewBox="0 0 25 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>下拉</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="条件查询-已设置过行业信息"
          transform="translate(-1146.000000, -701.000000)"
          fill="#9CA6B9"
          fill-rule="nonzero"
        >
          <g id="编组-8" transform="translate(431.000000, 172.000000)">
            <g id="下拉" transform="translate(716.000000, 529.000000)">
              <polygon
                id="路径-12"
                transform="translate(12.000000, 12.676777) scale(1, -1) translate(-12.000000, -12.676777) "
                points="16.6464466 9.64644661 17.3535534 10.3535534 12 15.7071068 6.64644661 10.3535534 7.35355339 9.64644661 12 14.293"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
